/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {buildCustomEventExampleCodes} from './custom-event-commons';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-custom-event-example-code',
  template: `
    <div class="form-group">
      <label class="col-md-3 control-label">Example Code (simple)</label>
      <div class="col-md-9">
        <p class="form-control-static"><code>{{ exampleCode }}</code></p>
        <span class="small help-block">This code can be put inside a script block in a layout to count the custom event with Adnuntius</span>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-3 control-label">Example Code (with a custom value)</label>
      <div class="col-md-9">
        <p class="form-control-static"><code>{{ exampleCodeWithCustomValue }}</code></p>
        <span class="small help-block">This code can be put inside a script block in a layout to add a custom value to a custom event with Adnuntius</span>
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-3 control-label">Example Code (with multiple custom events)</label>
      <div class="col-md-9">
        <p class="form-control-static"><code>{{ exampleCodeWithMultipleEvents }}</code></p>
        <span class="small help-block">This code can be put inside a script block in a layout to send multiple different custom events to Adnuntius</span>
      </div>
    </div>
  `
})
export class CustomEventExampleCodeComponent implements OnChanges {
  @Input() eventId: string;
  exampleCode = '';
  exampleCodeWithCustomValue = '';
  exampleCodeWithMultipleEvents = '';

  ngOnChanges(): void {
    const examples = buildCustomEventExampleCodes(this.eventId || '');
    this.exampleCode = examples.exampleCode;
    this.exampleCodeWithCustomValue = examples.exampleCodeWithCustomValue;
    this.exampleCodeWithMultipleEvents = examples.exampleCodeWithMultipleEvents;
  }
}
